import template from 'text!./generalCoverages.html';
import controller from './generalCoveragesCtrl';

/**
 * @ngdoc component
 * @name ama-cpp-general-coverages
 *
 * @description  A bop component to display the general coverages step into a wizard flow
 *
 */
export default {
    controller: controller,
    template: template,
    bindings: {
        updateCoverages: '='
    }
};


//////////////////
// WEBPACK FOOTER
// ./app/customer/js/src/edge/quoteandbind/ama/cpp/components/coverages/general/index.js
// module id = 812
// module chunks = 0